<script lang="ts">
	import Textfield from '@smui/textfield/styled';
	import Button from '../../Button.svelte';
	import type { Item } from 'DragNDrop';

	export let items: Item[];
	export let onSearchSortingChange: (items: Item[]) => void;
	export let filter: string;

	//1 alphabet a->z,2 z->a
	//10 date newest to oldest, 20 oldest to newest
	let sort = 1;

	const arrowIcon = {
		1: 'south',
		2: 'north'
	};

	function handleSorting() {
		switch (sort) {
			case 1:
				items = items.sort(function (a, b) {
					var nameA = a.name.toLowerCase(),
						nameB = b.name.toLowerCase();
					return nameA < nameB ? -1 : 1;
				});
				break;
			case 2:
				items = items.sort(function (a, b) {
					var nameA = a.name.toLowerCase(),
						nameB = b.name.toLowerCase();
					return nameA > nameB ? -1 : 1;
				});
				break;
			case 10:
				items = items.sort(function (a, b) {
					return new Date(b.firstRun).getTime() - new Date(a.firstRun).getTime();
				});
				break;
			case 20:
				items = items.sort(function (a, b) {
					return new Date(a.firstRun).getTime() - new Date(b.firstRun).getTime();
				});
				break;
		}
		onSearchSortingChange(items);
	}
</script>

<div class="row searchContainer">
	<Textfield
		type="search"
		input$name="personaName"
		label="Filter"
		class="fullwidth"
		variant="outlined"
		bind:value={filter}
	/>
	<div class="button-container">
		<Button
			icon={sort < 10 ? arrowIcon[sort] : ''}
			on:click={() => {
				sort === 1 ? (sort = 2) : (sort = 1);
				handleSorting();
			}}
		>
			A - Z
		</Button>
		<Button
			icon={sort >= 10 ? arrowIcon[sort / 10] : ''}
			on:click={() => {
				sort === 10 ? (sort = 20) : (sort = 10);
				handleSorting();
			}}
		>
			date
		</Button>
	</div>
</div>

<style>
	.searchContainer {
		margin-bottom: 5px;
		margin-top: 5px;
		width: 100%;
		padding: 0.3em;
	}
	.row {
		display: flex;
		text-align: left;
		flex-direction: row;
		align-items: center;
	}

	.row > :global(div:first-child) {
		min-width: 80px;
		padding-bottom: 0;
	}

	.button-container {
		margin-left: 5px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
</style>
